module.exports = __webpack_public_path__ + "img/glow-green-m.244c4b13.png";